import Layout from 'layout';
import { Can } from 'components/Can';
import { SpecializeReviewFormCreate } from 'features/SpecializeReview/pages';
import { LayoutProvider } from '../layout/context/layoutcontext';

function SpecializeReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="create" on="specialize_review">
          <SpecializeReviewFormCreate />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default SpecializeReviewFormCreatePage;
